<template>
  <el-dialog :visible="dialogVisible" width="800px" @close="close">
    <template slot="title">
      <div class="shuju_title">
        <div class="shuju_title_text">
          <span>{{ $t('order.detail.title') }}</span>
        </div>
      </div>
    </template>
    <div class="orderInfo" v-if="orderInfo">
      <div class="header">
        <div class="flex">
          <span>{{ $t('order.detail.orderNo') }}：</span>
          <span>{{ orderInfo.outTradeNo }}</span>
        </div>
        <div class="flex">
          <span>{{ $t('order.detail.orderDistance') }}：</span>
          <span>{{ orderInfo.distance }}km</span>
        </div>
        <div
          class="trip"
          v-if="orderInfo.state"
          :style="{ color: stateColors[orderInfo.state] || '' }"
        >
          {{ orderStateLabel(orderInfo.state) }}
        </div>
      </div>
      <div class="cont-body">
        <div class="body-l-r">
          <h3 class="body-title">{{ $t('order.detail.deliveryInfo') }}</h3>
          <div class="body-pd bot-line">
            <div class="flex">
              <span>{{ $t('order.detail.storeName') }}：</span>
              <span class="body-pd-color">{{ orderInfo.storeName }}</span>
            </div>
            <div class="flex">
              <span>{{ $t('order.detail.pushTime') }}：</span>
              <span>{{ orderInfo.createdAt }}</span>
            </div>
            <div class="flex">
              <span>{{ $t('order.detail.orderType') }}：</span>
              <span>{{ $t('order.detail.takeaway') }}</span>
            </div>
            <div class="flex">
              <span>{{ $t('order.detail.actualAmount') }}：</span>
              <span class="body-pd-color2">￥{{ orderInfo.actualMoney || 0 }}</span>
            </div>
          </div>
          <div>
            <h3 class="body-title">{{ $t('order.detail.orderItems') }}</h3>
            <div class="body-pd">
              <div class="flex">
                <span>{{ $t('order.detail.orderCode') }}：</span>
                <span>{{ orderInfo.originOutTradeNo }}（{{ $t('order.detail.seqPrefix') }}：</span>
                <span class="wei color-green">{{ `#${orderInfo.pickCode}` }}</span>
                <span>）</span>
              </div>
              <div class="flex">
                <span>{{ $t('order.detail.orderChannel') }}：</span>
                <span>{{ orderInfo.sourceName }}</span>
              </div>
              <div class="flex">
                <span style="min-width:60px;">{{ $t('order.detail.orderNote') }}：</span>
                <span>{{ orderInfo.note }}</span>
              </div>
              <div class="flex">
                <span>{{ $t('order.detail.goodsAmount') }}：</span>
                <span class="body-pd-color2">￥{{ orderInfo.originMoney || 0 }}</span>
              </div>
              <div class="flex">
                <span style="min-width:60px;">{{ $t('order.detail.goodsDetail') }}：</span>
                <span>{{ formatGoodsInfo(orderInfo.goodsInfo) }}</span>
              </div>
              <div class="flex" v-if="orderInfo.pickCode">
                <span>{{ $t('order.detail.pickCode') }}：</span>
                <span>{{ orderInfo.pickCode || '--' }}</span>
              </div>
              <div class="flex" v-if="orderInfo.pickImg">
                <span>{{ $t('order.detail.pickPhoto') }}：</span>
                <el-image style="width: 60px; height: 60px;" :src="orderInfo.pickImg"></el-image>
              </div>
              <div class="flex" v-if="orderInfo.receiveCcode">
                <span>{{ $t('order.detail.receiveCode') }}：</span>
                <span>{{ orderInfo.receiveCcode || '--' }}</span>
              </div>
              <div class="flex" v-if="orderInfo.endImg">
                <span>{{ $t('order.detail.receivePhoto') }}：</span>
                <el-image style="width: 60px; height: 60px;" :src="orderInfo.pickImg"></el-image>
              </div>
            </div>
          </div>
        </div>
        <div class="body-l-r">
          <h3 class="body-title">{{ $t('order.detail.locationInfo') }}</h3>
          <div class="body-pd">
            <div class="flex">
              <section class="debug-d debug-trip" style="background: #2a75ed;">{{ $t('common.start') }}</section>
              <h4>{{ orderInfo.startAddress }}</h4>
            </div>
            <span class="mar_l25">{{ orderInfo.startTel }}</span>
          </div>
          <div class="body-pd" style="padding-top: 0px;">
            <div class="flex">
              <section class="debug-d debug-trip" style="background: #ff8000;">{{ $t('common.end') }}</section>
              <h4>{{ orderInfo.endAddress }}</h4>
            </div>
            <span class="mar_l25">{{ `${orderInfo.endUsername}(${ orderInfo.endTel })` }}</span>
          </div>
        </div>
      </div>
      <div class="footer border-b">
        <h3 class="body-title">{{ $t('order.detail.riderInfo') }}</h3>
        <div class="footer-cont flex">
          <img class="footer-cont-img" src="~@/assets/img/moren.png" alt srcset />
          <span class="footer-cont-ls">{{ $t('order.detail.riderName') }}：{{ orderInfo.realName || '--' }}</span>
          <span class="footer-cont-ls">{{ $t('order.detail.riderTel') }}：{{ orderInfo.tel || '--' }}</span>
          <span class="footer-cont-ls">
            {{ $t('order.detail.expectedIncome') }}：
            <span class="body-pd-color2" style="color: #67c23a;">￥{{ orderInfo.commission || '--' }}</span>
          </span>
        </div>
      </div>
      <div class="footer">
        <h3 class="body-title" style="padding-bottom: 10px;">{{ $t('order.detail.operationLog') }}</h3>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="operate" :label="$t('common.operation')" align="center"></el-table-column>
          <el-table-column prop="content" :label="$t('order.detail.content')" align="center"></el-table-column>
          <el-table-column prop="createdAt" :label="$t('order.detail.operateTime')" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import RoutePlan from '@/plugins/routePlan.vue';
import { orderInfo } from '@/api/order';
export default {
  components: {
    RoutePlan
  },
  data() {
    return {
      dialogVisible: false,
      orderInfo: null,
      stateColors: {
        1: '#2a75ed',
        2: '#f56c6c',
        3: '#67c23a',
        4: '#4caf50',
        5: '#999',
        6: '#a40000'
      },
      tableData: []
    };
  },
  methods: {
    init(id) {
      this.dialogVisible = true;
      this.getOrderInfo(id);
    },
    getOrderInfo(id) {
      orderInfo({ id: id }).then((res) => {
        if (res.code == 1) {
          this.orderInfo = res.data;
          this.tableData = res.data.list;
          setTimeout(() => {
            const polyline = res.data.bicycling ? res.data.bicycling.polyline : [];
            this.$nextTick(() => {
              if (this.$refs.map) {
                this.$refs.map.init(polyline);
              }
            });
          }, 300);
        }
      });
    },
    close() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    formatGoodsInfo(info) {
      if (!info) {
        return this.$t('order.detail.none');
      }
      return info.replace(/\；/g, '、') || this.$t('order.detail.none');
    }
  }
};
</script>

<style lang="stylus" scoped>
$bgcolor = #f8f8f8;
$borderColor = #e8e8e8;

.shuju_title {
  min-height: auto !important;
  font-weight: bold;
  padding: 10px 0px;

  .shuju_title_text {
    font-size: 15px;
  }
}

>>>.el-table_2_column_14 {
}

>>>.cell {
  font-size: 12px;
  padding-left: 20px !important;
}

>>>.el-dialog {
  border-radius: 20px;
}

>>>.el-dialog__header {
  padding: 10px 0px;
  background: $bgcolor;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  border-radius: 6px 6px 0px 0px;

  .el-dialog__title {
    line-height: normal;
    font-size: 16px;
  }

  .el-dialog__headerbtn {
    top: 50%;
    transform: translateY(-50%);
  }
}

>>>.el-dialog__body {
  padding: 0px;
  border-radius: 0px 0px 6px 6px;
  overflow: auto;
}

.orderInfo {
  color: #666;
  font-size: 12px;

  .body-title {
    padding: 10px 10px 0;
    font-size: 15px;
    font-weight: bold;
    color: #333;
  }

  .header {
    position: relative;
    height: auto;
    padding: 10px 20px;
    border-bottom: 1px solid $borderColor;

    .trip {
      position: absolute;
      right: 40px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      font-weight: bold;
      color: #2a75ed;
    }
  }

  .body-pd-color {
    font-weight: bold;
    color: #2a75ed;
  }

  .body-pd-color2 {
    font-weight: bold;
    color: #ff8000;
  }

  .cont-body {
    display: flex;
    border-bottom: 1px solid $borderColor;

    .body-l-r {
      flex: 1;
      display: flex;
      flex-direction: column;

      .body-pd {
        padding: 10px 20px;

        .title-color {
          color: #FF8615;
          font-weight: bold;
        }
      }

      .map {
        flex: 1;
        width: 100%;
        height: 100%;
        background: pink;
      }

      .bot-line {
        border-bottom: 1px solid $borderColor;
      }

      &:nth-child(1) {
        border-right: 1px solid $borderColor;
      }
    }
  }

  .footer {
    .footer-cont {
      padding: 10px 10px 10px 20px;

      .footer-cont-img {
        width: 30px;
        height: 30px;
      }

      .footer-cont-ls {
        margin-left: 10px;
      }
    }
  }

  .border-b {
    border-bottom: 1px solid $borderColor;
  }
}
</style>
